import type { Group } from '@/api'

import type { GroupWithUserData } from './types'

export const createHierarchy = (inputArray: Group[]) => {
  const groupMap = new Map<string | undefined, GroupWithUserData>()

  inputArray.forEach((item) => {
    groupMap.set(item.gid, {
      ...item,
      gid: item.gid ?? '',
      name: item.name ?? '',
      organization: item.organization ?? '',
      parent: item.parent ?? '',
      children: [],
    })
  })

  const hierarchy: GroupWithUserData[] = []

  groupMap.forEach((item) => {
    const parentGid = item.parent

    if (parentGid) {
      const parentItem = groupMap.get(parentGid)

      if (parentItem) {
        parentItem.children.push(item)
      } else {
        hierarchy.push(item)
      }
    } else {
      hierarchy.push(item)
    }
  })

  return hierarchy
}
